import { useState } from "react";
import View from "../Base/View";
import Image from "../Base/Image";
import Price from "../Price";
import Text from "../Base/Text";
import Block from "../Base/Block";
import './index.scss'

const CouponItem = (prop: {
    couponInfo: any,
    // valid: boolean,
    //是否有效
    state: number,
    //优惠券状态：0，领取未使用；1:，领取已使用；2，领取已过期；3，未领取可领；4:，未领取不可领；5：已领取待选择使用
    select: boolean,
    onClick?: (couponInfo: any)=>void
}) => {
    const { couponInfo, state, select } = prop;
    const [isDesUnfold, setDesUnfold] = useState<boolean>(false)
    const [initState, setInitState] = useState<boolean>(true);
    return <View
        className={
            'coupon-list-item ' +
            (isDesUnfold ? 'coupon-list-item-unfold' : '') +
            ' ' +
            (state == 1 || state == 2 || state == 4
                ? 'coupon-list-item-invalid'
                : '')
        }
    >
        <View className="flex-conainer" onClick={()=>{
            if(prop.onClick){
                prop.onClick(couponInfo)
            }
        }}>
            <Image
                className="coupon-thumb-left flex-fix"
                src={require('../../images/coupon-thumb-left.png')}
            ></Image>
            <View className="coupon-thumb flex-conainer-column flex-fix">
                <View className="coupon-value">
                    <Price
                        value={'¥' + couponInfo.DiscountAmount}
                        size={50}
                        color="#ffffff"
                    ></Price>
                </View>
                <View className="coupon-condition">{couponInfo.RequireStr}</View>
            </View>
            <View className="coupon-meta flex-conainer flex-grow">
                {(state == 1 || state == 2) && (
                    <Image
                        className="coupon-state-icon"
                        src={
                            require('../../images/coupon-' + (state == 2 ? 'expired' : 'used') + '.png')
                        }
                    ></Image>
                )}
                {state == 3 && couponInfo.CustomerReceivedCount > 0 && (
                    <Image
                        className="coupon-state-icon coupon-state-icon-received"
                        src={require('../../images/coupon-received.png')}
                    ></Image>
                )}
                {/*  优惠券信息  */}
                <View className="flex-conainer-column flex-grow coupon-title-container">
                    <View className="flex-grow coupon-title">{couponInfo.Name}</View>
                    {/*  有效期，领取/使用按钮  */}
                    <View className="flex-conainer flex-fix coupon-time-btn">
                        {couponInfo.ValidTimeStr != null ? (
                            <View className="coupon-time flex-grow">
                                <Text>{couponInfo.ValidTimeStr}</Text>
                            </View>
                        ) : (
                            <View className="coupon-time flex-grow"></View>
                        )}
                        {state == 3 && (
                            <Block>
                                {(couponInfo.DiscountLimitationId != 10 ||
                                    couponInfo.CustomerReceivedCount <
                                    couponInfo.LimitationTimesPerCustomer) && (
                                        <View
                                            className="coupon-get-btn flex-fix coupon-get-btn-receive"
                                            // data-index={index}
                                        >
                                            {couponInfo.CustomerReceivedCount > 0
                                                ? '再领一张'
                                                : '点击领取'}
                                        </View>
                                    )}
                            </Block>
                        )}
                        {state == 0 && (
                            <Block>
                                <View
                                    className="coupon-get-btn flex-fix"
                                    // data-index={index}
                                    style={{
                                        display: 'none',
                                    }}
                                >
                                    去使用
                                </View>
                            </Block>
                        )}
                    </View>
                    {/*  描述预览，展开描述按钮  */}
                    <View className="flex-conainer  coupon-des-btn-container">
                        <View className="flex-grow coupon-des-preview">
                            {isDesUnfold ? '' : couponInfo.Description}
                        </View>
                        <Image
                            className="coupon-des-unfold flex-fix"
                            src={
                                require('../../images/coupon-detail-' +
                                (isDesUnfold ? 'un' : '') +
                                'fold.png')
                            }
                            onClick={(e)=>{
                                e.stopPropagation();
                                e.preventDefault()
                                setDesUnfold(!isDesUnfold)
                                setInitState(false)
                            }}
                        ></Image>
                    </View>
                </View>
                {/*  勾选按钮  */}
                {state == 5 && (
                    <Image
                        className="coupon-select flex-fix"
                        src={
                            require('../../images/cart-' + (select ? 'select' : 'unselect') + '.png')
                        }
                    ></Image>
                )}
            </View>
        </View>
        <View
            className={
                'coupon-des-full coupon-des-full-' +
                (initState ? 'init' : isDesUnfold ? 'unfold' : 'fold')
            }
        >
            <Text>{couponInfo.Description}</Text>
        </View>
    </View>
}

export default CouponItem